import React, {useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment'
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconBackArrow from "../../assets/images/IconBackArrow.png";
import IconForwardArrow from "../../assets/images/IconForwardArrow.png";
import Button from "@material-ui/core/Button";
import { Link, useLocation } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    marginBottom: "30px",
  },

  marginBottomStyle: {
    marginBottom: "20px",
  },
  marginBottomStyle2: {
    marginBottom: "30px",
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    float: "right",
  },
  backButton: {
    fontSize: "16px",
    "&:hover": {
      background: "none",
    },
    color: "#19181699",
  },

  tabletitle: {
    fontWeight: 600,
    marginTop: "10px",
    marginBottom: "20px",
    padding: "5px 15px",
    fontSize: "20px",
  },

  tableStyle: {
    "& td": {
      borderBottom: "none !important",
      padding: "0px 24px 6px 16px",
      fontSize: "16px",
    },
    "& td:first-child": {
      width: "210px",
    },
  },
  tableStyle2: {
    "& td": {
      borderBottom: "none !important",
      padding: "0px 0px 6px 16px !important",
      fontSize: "14px",
    },
  },
 
  leftPaper: {
    width: "97%",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
  },
  rightPaper:{
    width: "97%",
    background: "#EFEFFA",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    height: "100%",
    float: "right",
  },
  tdImageStyle:{
    position: "relative",
    top: "-2px",
    margin: "0 10px",
  }
}));

const TransactionDetails = () => {
  const classes = useStyles();
  const location = useLocation()

  useEffect(()=>{
    console.log('state', location.state)
  },[])

  return (
    <>
      <div className={classes.root}>
        <Typography variant="h5" className={classes.marginBottomStyle}>
          Transaction ID - {location.state.transactionNumber}
        </Typography>

        <div>
          <Grid container>
            <Grid item xs={6}>
              <div className={classes.leftPaper}>
                <div className={classes.marginBottomStyle2}>
                  <Typography className={classes.tabletitle}>
                    Basic Information
                  </Typography>
                  <TableContainer>
                    <Table
                      className={classes.tableStyle}
                      size="small"
                      aria-label="caption table"
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell>Country of Origin</TableCell>
                          <TableCell>{location.state.originCountry}</TableCell>
                        </TableRow>
                     
                        <TableRow>
                          <TableCell>Destination</TableCell>
                          <TableCell>{location.state.destinationCountry}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Requested at</TableCell>
                          <TableCell>
                            {/* {location.state.createdAt.moment.format('MM')} */}
                          {moment(location.state.createdAt).format('DD MMM YYYY h:mm A')}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Processed at</TableCell>
                          <TableCell>
                          {moment(location.state.updatedAt).format('DD MMM YYYY h:mm A')}
                          </TableCell>
                        </TableRow>
                        {/* <TableRow>
                          <TableCell>Received at</TableCell>
                          <TableCell>25 July 2021 &nbsp;12:00 AM</TableCell>
                        </TableRow> */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <div>
                  <Typography className={classes.tabletitle}>
                    Amount Details
                  </Typography>
                  <TableContainer>
                    <Table
                      className={classes.tableStyle}
                      size="small"
                      aria-label="caption table"
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell>Currency Conversion</TableCell>
                          <TableCell>
                          {location.state.transaction.fromCurrency}
                            <img
                              src={IconForwardArrow}
                              alt=""
                             className={classes.tdImageStyle}
                            />{" "}
                            {location.state.transaction.toCurrency}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Amount Sent</TableCell>
                          <TableCell>{location.state.transaction.amountToTransfer}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Charges</TableCell>
                          <TableCell>{location.state.transaction.charge}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Recipient Gets</TableCell>
                          <TableCell>{location.state.transaction.amountReceivable.toFixed(2)}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
               className={classes.rightPaper}
              >
                <Typography className={classes.tabletitle}>
                  Transaction Issues
                </Typography>
                <TableContainer>
                  <Table
                    className={classes.tableStyle2}
                    size="small"
                    aria-label="caption table"
                  >
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          No issues has occurred during the transaction.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>The cash has been delivered.</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <div>
        <Button
          component={Link}
          to="/transactions"
          className={classes.backButton}
          startIcon={<img src={IconBackArrow} alt="" />}
          disableRipple={true}
        >
          Back
        </Button>
        <Button
          component={Link}
          to="/transfer-receipt"
          variant="contained"
          color="primary"
          className={`${classes.buttonStyle}`}
        >
          View Receipt
        </Button>
      </div>
    </>
  );
};

export default TransactionDetails;
